import { SecurityEnumLabels } from "@boundless/bl-api-client/customer/models/SecurityEnumLabels"

import type {
  DebtSchedule,
  SecurityEnum,
} from "@boundless/bl-api-client/customer/models"
import type { Row } from "@tanstack/react-table"
export const debtsColumns = [
  {
    accessorKey: "lenderName",
    header: "Lender Name",
  },
  {
    accessorKey: "originalAmount",
    header: "Original Amount",
  },
  {
    accessorKey: "fundedDate",
    header: "Funded Date",
  },
  {
    accessorKey: "maturityDate",
    header: "Maturity Date",
  },
  {
    accessorKey: "currentBalance",
    header: "Current Balance",
  },
  {
    accessorKey: "paymentAmount",
    header: "Payment Amount",
  },
  {
    accessorKey: "paymentFrequency",
    header: "Payment Frequency",
    cell: ({ row }: { row: Row<DebtSchedule> }) => {
      return (
        <div className="font-small capitalize">
          {row.getValue("paymentFrequency")}
        </div>
      )
    },
  },
  {
    accessorKey: "security",
    header: "Security",
    cell: ({ row }: { row: Row<DebtSchedule> }) => {
      return (
        <div className="font-small">
          {SecurityEnumLabels[row.getValue("security") as SecurityEnum]}
        </div>
      )
    },
  },
]
